export default {
  title: 'Exceljs React'
};
